import React, {useState} from "react";
import { data } from "../data/data";

const Part1 = () => {
	const { title, sub, wordmateri1, wordmateri2, wordmateri3 } = data[0];
	const [ukuranH,setUkuranH]=useState(19)
	const [ukuranP,setUkuranP]=useState(15)
	const sizeplus =()=>{
		setUkuranH(ukuranH+1)
		setUkuranP(ukuranP+1)
	}
	const sizemin =()=>{
		setUkuranH(ukuranH-1)
		setUkuranP(ukuranP-1)
	}
	return (
		<div>
			<div className="container">
			<div className="d-flex justify-content-end">
			<button className="btnplus" onClick={sizeplus}><h6>A<sub>+</sub></h6></button>
			<button className="btnplus" onClick={sizemin}><h6>A<sub>-</sub></h6></button>
			</div>
				<div className="row">
					<div className=" col-sm-3 col-md-12 col-lg-12">
						<div
							style={{
								fontSize: "19px",
								width: "50%",
								color: "green",
								borderRadius: "25px",
							}}
						>
							<strong style={{fontSize:`${ukuranH}px`}}>{title}</strong>
						</div>
					</div>
					<div className="col-sm mt-2">
						<div
							style={{
								width: "100%",
								borderStyle: "inset",
								borderRadius: "25px",
								borderColor: "#70db70",
								paddingTop: "10px",
								textAlign: "justify",
								boxShadow: "5px 5px #888888",
								backgroundColor: "#f0f5f5",
							}}
						>
							<div className="col">
								<div
									style={{
										width: "100%",
										marginTop: "1rem",
										textAlign: "justify",
									}}
								>
									<div
										style={{
											textAlign: "justify",
											lineHeight: "20px",
											paddingRight: "10px",
										}}
									>
										{sub.map((item, index) => (
											<div key={index}>
												<ol style={{fontSize:`${ukuranP}px`}}>
													{item.no} {item.word}
												</ol>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					style={{
						textIndent: "2rem",
						width: "100%",
						textAlign: "justify",
						lineHeight: "35px",
						marginTop:"1.5rem"
					}}
				>
					<p style={{fontSize:`${ukuranP}px`}}>Setelah kalian berhasil memahami materi sebelumnya, yaitu sistem pertidaksamaan linear dua variabel. Kali ini kalian akan belajar tentang program linear, nah seru kan! Ayo sekarang kalian baca terlebih dahulu pengantar di bawah ini, agar kalian mudah paham dan mengerti &#128513; &#128077;</p>
				</div>
				<div className="card mt-2 border-success shadow  bg-body rounded mt-2">
					<div
						style={{ backgroundColor: "#2d8659" }}
						className="card-header text-white text-center"
					>
						<h6 style={{fontSize:`${ukuranH}px`}}>Pengantar</h6>
					</div>
					<div className="card-body" style={{ backgroundColor: "#f0f5f5", fontSize:`${ukuranP}px` }}>
						<div className="row">
							<div className="col-sm-12">
								<div
									style={{
										textIndent: "2rem",
										width: "100%",
										textAlign: "justify",
										lineHeight: "35px",
									}}
								>
									{wordmateri2}
								</div>
							</div>
							<div className="col-sm-12 mt-3">
								<div
									style={{
										textIndent: "2rem",
										width: "100%",
										textAlign: "justify",
										lineHeight: "35px",
									}}
								>
									{wordmateri3}
								</div>
							</div>
							<div className="col-sm-12 mt-3">
								<div
									style={{
										textIndent: "2rem",
										width: "100%",
										textAlign: "justify",
										lineHeight: "35px",
									}}
								>
									{wordmateri1}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Part1;
